/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { GetUnitResponse } from '../models/get-unit-response';
import { UnitResponse } from '../models/unit-response';

/**
 * Unit APIs
 */
@Injectable({ providedIn: 'root' })
export class UnitService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllUnits()` */
  static readonly GetAllUnitsPath = '/api/v1/units';

  /**
   * Get unit lists.
   *
   * Returns all units as pages.
   * The results will be filtered, sorted based on the provided queries.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllUnits()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllUnits$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetUnitResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      UnitService.GetAllUnitsPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetUnitResponse>;
        })
      );
  }

  /**
   * Get unit lists.
   *
   * Returns all units as pages.
   * The results will be filtered, sorted based on the provided queries.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllUnits$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllUnits(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;
    },
    context?: HttpContext
  ): Observable<GetUnitResponse> {
    return this.getAllUnits$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUnitResponse>): GetUnitResponse => r.body)
    );
  }

  /** Path part for operation `getUnitById()` */
  static readonly GetUnitByIdPath = '/api/v1/units/{id}';

  /**
   * fetch unit details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnitById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitById$Response(
    params: {
      /**
       * The unit id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<UnitResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      UnitService.GetUnitByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<UnitResponse>;
        })
      );
  }

  /**
   * fetch unit details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUnitById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitById(
    params: {
      /**
       * The unit id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<UnitResponse> {
    return this.getUnitById$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnitResponse>): UnitResponse => r.body)
    );
  }
}
